import React, { useState } from 'react'
import { Button, Form, Input, message, Modal } from 'antd'
import { inject, observer } from 'mobx-react'
import { useParams } from 'react-router-dom'
import { PROPOSAL_STATUS } from '../../../constants'

const DistributionVotesConfirmModal = props => {
  const {
    isModalVisible,
    handleCloseModal,
    confirmModalType,
    proposalStore,
    DistributionVotesStore,
    isAllAssetSelected,
    getDiffAssets,
    listDataHistory,
    managementAssetWarehouseStore,
  } = props

  const { defaultApprovalConfigUpdate } = proposalStore
  const { distributionVotesDetails } = DistributionVotesStore
  const { proposalId: proposalId } = useParams()

  const [form] = Form.useForm()

  const [comment, setComment] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const onFinish = async () => {
    if (isAllAssetSelected === false) {
      return message.info(
        `Tài sản ${JSON.parse(getDiffAssets)
          .map(item => item.assetName)
          .join(', ')} không tồn tại!`
      )
    }
    const { approvalLevels } = defaultApprovalConfigUpdate
    const currentStepInfo =
      approvalLevels.find(item => item.status === PROPOSAL_STATUS.PENDING) || {}
    const currentStep = currentStepInfo.level || 0
    let nextStepInfo = {}
    if (currentStep < approvalLevels.length - 1) {
      nextStepInfo = approvalLevels[currentStep + 1]
    }
    if (
      !nextStepInfo.username &&
      confirmModalType === PROPOSAL_STATUS.APPROVAL &&
      nextStepInfo.level
    ) {
      handleCancelModal()
      return message.warning(`Vui lòng chọn ${nextStepInfo.name}!`)
    }

    let messageText = 'Thành công!'
    let status = null
    if (confirmModalType === PROPOSAL_STATUS.APPROVAL) {
      messageText = 'Duyệt yêu cầu thành công!'
      status = PROPOSAL_STATUS.APPROVED
    }
    if (confirmModalType === PROPOSAL_STATUS.REJECT) {
      messageText = 'Bạn đã từ chối yêu cầu này!'
      status = PROPOSAL_STATUS.REJECTED
    }
    const payload = {
      status: status,
      comment: comment,
      next_approval_level: nextStepInfo.allow_edit
        ? {
            code: nextStepInfo.code,
            username: nextStepInfo.username,
          }
        : null,
    }
    if (!payload?.next_approval_level) {
      const promises = listDataHistory?.map(item =>
        managementAssetWarehouseStore
          .createManagementAssetHistoryWarehouse({
            asset_id: item.asset_id,
            tax: item.tax,
            price: item.price,
            total_money: item.total_money,
            quantity: item.amount,
            created_user: distributionVotesDetails.create_user.user_name,
            type: 'EXPORT',
          })
          .catch(error => {
            console.error('Error creating asset history:', error)
          })
      )

      Promise.all(promises)
    }

    try {
      setIsLoading(true)
      await DistributionVotesStore.approveProposal(proposalId, payload)
      await DistributionVotesStore.getDistributionVotesDetail(proposalId)
      await DistributionVotesStore.getDistributionVotesComment(proposalId)
      handleCancelModal()
      message.success(messageText)
    } catch (err) {
      handleCancelModal()
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsLoading(false)
    }
  }

  const handleCancelModal = () => {
    setComment(null)
    handleCloseModal()
  }

  const handleInputComment = e => {
    setComment(e.target.value)
  }
  return (
    <Modal visible={isModalVisible} footer={null} onCancel={handleCloseModal}>
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 10 }}>
          {`Bạn có chắc chắn muốn ${
            confirmModalType === PROPOSAL_STATUS.APPROVAL ? 'duyệt' : 'Từ chối'
          } yêu cầu này?`}
        </div>
        {confirmModalType === PROPOSAL_STATUS.REJECT && (
          <Form form={form} onFinish={onFinish} layout={'vertical'}>
            <Form.Item
              name={'comment'}
              label={'Lý do:'}
              rules={[{ required: true, message: 'Vui lòng nhập lý do!' }]}>
              <Input.TextArea
                onChange={handleInputComment}
                value={comment}
                placeholder={'Nhập lý do...'}
                autoSize={{
                  minRows: 2,
                  maxRows: 6,
                }}
              />
            </Form.Item>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 10,
              }}>
              <Button onClick={handleCancelModal}>Đóng</Button>
              <Button htmlType={'submit'} type={'danger'}>
                Từ chối yêu cầu
              </Button>
            </div>
          </Form>
        )}
      </div>
      {confirmModalType === PROPOSAL_STATUS.APPROVAL && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 10,
            marginTop: 20,
          }}>
          <Button onClick={handleCancelModal}>Đóng</Button>
          <Button onClick={onFinish} type={'primary'} loading={isLoading}>
            Duyệt yêu cầu
          </Button>
        </div>
      )}
    </Modal>
  )
}

DistributionVotesConfirmModal.propTypes = {}

export default inject(
  'proposalStore',
  'DistributionVotesStore',
  'managementAssetWarehouseStore'
)(observer(DistributionVotesConfirmModal))
